import React, { ReactNode } from 'react';
import { REPORT_MALICIOUS_EMAIL_FORM_URL } from '../../../../../constants';

export const ATTACHMENT_SCAN_MESSAGES = {
  REJECTED: 'A file was rejected as malicious. Submit an Ellis to report it to the Security team.'
} as const;

export const renderAttachmentErrorMessage = (error: string): ReactNode => {
  if (error === ATTACHMENT_SCAN_MESSAGES.REJECTED) {
    return (
      <span>
        A file was rejected as malicious.{' '}
        <a href={REPORT_MALICIOUS_EMAIL_FORM_URL} target="_blank" rel="noopener noreferrer">
          Submit an Ellis
        </a>{' '}
        to report it to the Security team.
      </span>
    );
  }

  return error;
};

export const getAttachmentUploadErrorMessage = (failed: PromiseRejectedResult[]): string => {
  const isScanRejection = failed.some(
    r => r.reason instanceof Error && (Object.values(ATTACHMENT_SCAN_MESSAGES) as string[]).includes(r.reason.message)
  );

  if (isScanRejection) {
    return ATTACHMENT_SCAN_MESSAGES.REJECTED;
  }

  return `Failed to upload ${failed.length} attachment(s). Please try again.`;
};
